var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.5 117.746L381 44.246C386.125 36.996 384.5 26.996 377.375 21.871L351.5 2.996C344.377 -2.2 334.389 -0.627 329.208 6.507L288 63.246L246.792 6.507C241.611 -0.627 231.623 -2.2 224.5 2.996L198.625 21.871C191.5 26.996 189.875 36.996 195 44.246L248.5 117.746L6.43 439.454C2.257 445.001 0 451.754 0 458.695V479.996C0 497.669 14.327 511.996 32 511.996H544C561.673 511.996 576 497.669 576 479.996V458.695C576 451.754 573.743 445.001 569.57 439.454L327.5 117.746ZM288 287.996L404.375 447.996H171.625L288 287.996Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampground);
export default __webpack_public_path__ + "static/media/campground.4c9c47f3887a3e24b0fdbf1acf41c036.svg";
export { ForwardRef as ReactComponent };